export const SET_SITES_FROM_SERVER = 'SET_SITES_FROM_SERVER';
export const SET_BROWSER_DATA = 'SET_BROWSER_DATA';
export const CHANGE_BROWSER_DATA_WHEN_DELETE = 'CHANGE_BROWSER_DATA_WHEN_DELETE';
export const CHANGE_BROWSER_DATA_WHEN_ADD = 'CHANGE_BROWSER_DATA_WHEN_ADD';
export const CHANFE_BROWSER_DATA_WHEN_RENAME = 'CHANFE_BROWSER_DATA_WHEN_RENAME';
export const SET_FILE_CONTENT = 'SET_FILE_CONTENT';
